import React from 'react';

export const SummaryItem = ({ title, children }) => (
  <div className="w-full flex items-center space-x-2 text-sm">
    <div className="font-medium capitalize">{`${title}:`}</div>
    <div className=" font-medium text-primary">{children}</div>
  </div>
);
